import { BaseDataService } from './Base/BaseDataService';
import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { MessageApiDataResponse } from '../Models/Message/Message';
import { BaseApiDataResponse } from '../Models/ApiData';

export const MessageEndpoints = {
    MESSAGE: '/api/v1/back/messages/broadcast',
    SET_MESSAGE: '/api/v1/back/messages/broadcast',
};

export interface IMessageDataService {
    getMessage: (cts: XHRRequestCanceler) => Promise<MessageApiDataResponse>;

    setMessage: (
        body: {
            content: string;
            is_active: boolean;
        },
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;
}

class MessageDataService extends BaseDataService implements IMessageDataService {
    public getMessage = async (cts: XHRRequestCanceler) => {
        return this.get<MessageApiDataResponse>(MessageEndpoints.MESSAGE, cts);
    };

    public setMessage = async (
        body: {
            content: string;
            is_active: boolean;
        },
        cts: XHRRequestCanceler
    ) => {
        return this.put<BaseApiDataResponse>(MessageEndpoints.SET_MESSAGE, body, cts);
    };
}

const MessageDataServiceName = 'MessageDataService';
export { MessageDataService, MessageDataServiceName };
